Jelly.Payments.Show_Payment_Error = function(Parameters) {

	var Message = "";

	switch (Parameters.Action) { 
		case "Get Follower":
			// Contextualize error
			Message += "We had trouble processing your payment.  ";

			// Include helpful next steps
			Message += "  (No payment was charged. Please contact <a href=\"mailto:support@withfriends.co\">support@withfriends.co</a> for help.)";
			break;

		case "Change Membership":
		case "Charge Membership":
			if (Parameters.Ticket_Charged)
				Message += "Tickets were purchased for this event, but we "
			else
				Message += "We ";
			Message += "had trouble processing your membership payment.  ";

			// NO BREAK

		default: 
			// Contextualize error
			if (Message == "" && !Parameters.Change_Payment_Mode)
				Message += "We had trouble processing your payment.  ";

			switch (Parameters.Type) { 
				// Handle card errors
				case "card_error":
					switch(Parameters.Code){
						case "incorrect_cvc":

							// CVC error shows up for expiration date error sometimes	
							Message += "Your card's security code or expiration date is incorrect.";

							// Include helpful next steps
							Message += "  (";
							if (!Parameters.Ticket_Charged && !Parameters.Change_Payment_Mode)
									Message += "No payment was charged.  ";
							Message += "Please contact <a href=\"mailto:support@withfriends.co\">support@withfriends.co</a> for help.)";
							break;

						// Include decline code for declined cards, instructions to call bank
						case "card_declined":
							Message += Parameters.Message;
							if (Parameters.Decline_Code) { 
								Message += "  Your bank returned the code <i>" + Parameters.Decline_Code + "</i>";
							}

							// Include helpful next steps
							Message += "  (";
							if (!Parameters.Ticket_Charged && !Parameters.Change_Payment_Mode)
									Message += "No payment was charged.  ";
							Message += "Please correct your information or contact your bank for help.)";
							break;

						// Otherwise just show standard message
						default:
							Message += Parameters.Message;

							// Include helpful next steps
							Message += "  (";
							if (!Parameters.Ticket_Charged && !Parameters.Change_Payment_Mode)
									Message += "No payment was charged.  ";
							Message += "Please contact <a href=\"mailto:support@withfriends.co\">support@withfriends.co</a> for help.)";
							break;
					}
					break;

				// Handle network errors, etc.
				default: 
					// TODO - handle other stripe errors
					Message += Parameters.Message;
			}
			break;
	}

	// Show the error
	Jelly.Actions.Show_Result({
			Namespace: Parameters.Namespace
		,	Content: Message
	});

	// Track the error 

	// Generate tracking error message
	var Tracking_Message = Parameters.Action + " // ";
	
	if (Parameters.Type)
		Tracking_Message += Parameters.Type + ": ";
	Tracking_Message += Message;

	if (Parameters.Code) {
		Tracking_Message += " [";
		if (Parameters.Param)
			Tracking_Message += Parameters.Param + " - ";
		Tracking_Message += Parameters.Code;
		Tracking_Message += "]";
	}

	// Generate tracking data
	var Tracking_Data = {
			Message: Tracking_Message
		, Email_Address: Parameters.Email_Address
	};

	// Add values that would specifically come from Stripe.js
	if (Parameters.Expiration_Year)
		Tracking_Data.Data = Parameters.Expiration_Year;

	// Send to mixpanel
	if (window.mixpanel)
		mixpanel.track("Purchase Error", Tracking_Data);
};